<template>
  <div class="speakers">
    <div class="speakers-left">
      <div class="category"  v-for="item,index in category" :key="index" 
        @click="()=>changeCategory(item)"
        :class="{active: currentCategory === item.category_id }">{{item.category_name}}</div>
    </div>
    <div class="speakers-right">
      <div class="list">
        <div class="list-item" v-for="item,index in list" :key="index" @click.stop="selectedItem(item)">
          <img class="item-left" :src="item.image" alt="">
          <div class="item-center">
            <div class="name">{{item.name}}<span class="tag" v-for="ele,i in item.tag" :style="{background: item.bgColor[i]}" :key="i">{{ele}}</span></div>
            <div class="info">{{item.des}}</div>
          </div>
          <SvoiceTooltip :title="!audioFlag || (currentIndex !== index) ? '播放' : '暂停'">
            <img class="item-right" @click.stop="()=>clickAudioButton(item, index, !audioFlag || (currentIndex !== index))" :src="!audioFlag || (currentIndex !== index) ? playImage : stopImage" alt="">
          </SvoiceTooltip>
        </div>
      </div>
      <div class="pagination-container">
        <Pagination @jump="getList" :total="total" :resetPage="resetPage"></Pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getSpeakersList, getSpeakerCategoryList } from 'api/voices.js'
import { ARGBToRGBA } from 'utils/utils.js'
import Pagination from 'components/pagination.vue'
import { mixin } from 'utils/audio-mixin.js'
import SvoiceTooltip from '@/components/svoice-tooltip.vue'
const playImage = require('@/assets/images/play_small.png')
const stopImage = require('@/assets/images/stop_small.png')

export default {
  name: 'speakers',
  props: {
    visible: Boolean
  },
  components: {
    Pagination,
    SvoiceTooltip
  },
  mixins: [mixin],
  data() {
    return {
      category: [],
      list: [],
      currentCategory: 0,
      init: true,
      total: 0,
      resetPage: false,
      currentIndex: -1,
      playImage,
      stopImage
    }
  },
  watch: {
    visible(val) {
      if (!val) {
        this.audio.pause()
      }
    },
  },
  created() {
    // this.getList()
    this.getSpeakerCategoryList()
  },
  methods: {
    clickAudioButton (item, index, flag) {
      if (!item) {
        return
      }
      if (flag) {
        this.audioFlag = true
        this.currentIndex = index
        this.audio.src = item.demo_audio
        this.audio.play()
      } else {
        this.audioFlag = false
        this.currentIndex = -1
        this.audio.pause()
      }
      console.log(item,index)
    },
    async getList (page) {
      page.category_id = this.currentCategory
      const res = await getSpeakersList(page)
      this.resetPage = false
      console.log(res)
       const {list,total} = res.data
      const listCurSpeaker = list.map((ele) => {
        ele.bgColor = ele.tag_bg_color.map((item) => {
          return ARGBToRGBA(item)
        })
        return ele
      })
      this.total = total
      this.list = listCurSpeaker
      this.currentIndex = -1
      this.audio.pause()
      console.log(listCurSpeaker)
    },
    async getSpeakerCategoryList () {
      const res = await getSpeakerCategoryList()
      console.log(res)
      this.category = res.data;
    },
    changeCategory (item) {
      console.log(item, 'changeCategory')
      this.currentCategory = item.category_id
      this.resetPage = true
    },
    selectedItem (item) {
      this.$emit('selectedSpeaker', item)
    }
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.speakers {
  position: absolute;
  top: 70px;
  left: -1px;
  width: 850px;
  height: 530px;
  z-index: 10;
  color: #555555;
  font-size: 14px;
  background: #FFFFFF;
  box-shadow: 10px 10px 9px 0px rgba(204, 204, 204, 0.6);
  border-radius: 4px;
  border: 1px solid #EEEEEE;
  display: flex;
  .speakers-left {
    width: 100px;
    padding-top: 10px;
    .category {
      width: 100px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: #999999;
      cursor: pointer;
      &.active {
        background: #EEEEEE;
        color: #555555;
      }
    }
  }
  .speakers-right {
    // display: flex;
    // flex-wrap: wrap;
    // border-left: 1px solid #EEEEEE;
    // padding: 10px 40px 0;
    // align-content: baseline;
    // width: 100%;
    // justify-content: space-between;
    padding: 10px 40px 0;
    border-left: 1px solid #EEEEEE;
    width: 750px;
    .list {
      display: flex;
      flex-wrap: wrap;
      
      align-content: baseline;
      width: 100%;
      justify-content: space-between;
    }
    .list-item {
      display: flex;
      width: 320px;
      height: 60px;
      border-radius: 4px;
      border: 1px solid #EEEEEE;
      margin-top: 30px;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
      cursor: pointer;
      &:hover {
        border-color:#4E6EFF;
      }
      .item-left {
        width: 40px;
        height: 40px;
        margin-right: 15px;
        border-radius: 20px;

      }
      .item-center {
        font-size: 14px;
        flex: 1;
        text-align: left;
        color: #555555;
        .info {
          color: #999999;
          margin-top: 5px;
        }
        .tag {
          font-size: 10px;
          display: inline-block;
          padding: 1px 5px;
          background: #62C4E9;
          border-radius: 4px;
          color: #fff;
          margin-left: 6px;
        }
      }
      .item-right {
        width: 20px;
        height: 20px;
      }
    }
    .pagination-container {
      margin-top: 20px;
    }
  }
}
</style>
